/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BoundaryGeometryType {
	Polygon = 0,
	Circle = 1,
	Rectangle = 2,
}
